import React from "react";
import { EmojiEvents } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";

export const TOURNAMENT_TROPHY_COLOR = "#ca8a03";
export const TOURNAMENT_HEADER_TROPHY_WIDTH = 44;

interface Props {
  className?: string;
  fillHeight?: boolean;
}

export default function TournamentTrophyIcon({ className, fillHeight }: Props) {
  const classes = useStyles();
  return (
    <EmojiEvents
      className={[classes.icon, fillHeight && classes.iconFillHeight, className].filter(Boolean).join(" ")}
      aria-hidden
    />
  );
}

const useStyles = makeStyles({
  icon: {
    color: TOURNAMENT_TROPHY_COLOR,
    fontSize: "1.25rem",
    flexShrink: 0,
  },
  iconFillHeight: {
    display: "block",
    width: "100%",
    height: "100%",
    maxWidth: "100%",
    maxHeight: "100%",
    fontSize: "2.75rem",
  },
});
